import { TRANSLATIONS } from "../../Constants/Translations";
import { copyObject } from "../../Helper/CopyObject";

const notice_DeltaOs = "notice_DeltaOs";
const notice_GstaPro = "notice_GstaPro";

export const sortPatchNotesByVersionsDesc = (data) => {
  return data.sort((a, b) => {
    const v1 = a.version.split('.').map(Number);
    const v2 = b.version.split('.').map(Number);
    
    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
      const num1 = v1[i] || 0;
      const num2 = v2[i] || 0;
      if (num1 !== num2) return num2 - num1; // décroissant
    }
    return 0;
  });
}

/**
 * Sort all the links in updateNote_XXXX_XXXX_XXXX_XXXX format by version
 * @param {Array} links - array of links to sort
 * @returns {Array} - sorted array of links
 */
export const sortByVersion = (links) => {
  const extractVersion = (key) => {
    // Capture tous les groupes de chiffres à la fin du nom
    const parts = key.split('_');
    const versionParts = parts
      .filter(p => /^\d+$/.test(p)) // garde uniquement les segments numériques
      .map(Number);
    return versionParts;
  };

  return [...links].sort((a, b) => {
    const aVersion = extractVersion(a.translationKey);
    const bVersion = extractVersion(b.translationKey);

    for (let i = 0; i < Math.max(aVersion.length, bVersion.length); i++) {
      const valA = aVersion[i] || 0;
      const valB = bVersion[i] || 0;
      if (valA !== valB) {
        return valB - valA; // tri décroissant
      }
    }

    return 0; // mêmes versions
  });
};

/**
 * 
 */
export const normalizeNoticeFileNames = (links) => {
  return links.map((link) => {
    let linkCopied =  copyObject(link);
    if (link?.translationKey.includes(notice_DeltaOs)) {
      linkCopied.translationKey = TRANSLATIONS.NOTICE_DELTAOS;
    }
    if (link?.translationKey.includes(notice_GstaPro)) {
      linkCopied.translationKey = TRANSLATIONS.NOTICE_GSTAPRO;
    }
    return linkCopied;
  });
}

/**
 * Sort updateNote links based on their format
 * This function will check the first link's translationKey to determine the format.
 * @param {Array} links - array of links to sort
 * @returns {Array} - sorted array of links
 */
export const autoSortDocumentationLinks = (links) => {
  const regexUpdateNoteMachine = /^updateNote_[A-Z]+(_\d+)+$/;
  const regexUpdateNoteGsta =  /^updateNote(_\d+)+$/;
  const regexNotice = /notice_(DeltaOs|GstaPro)/;

  const firstLink = links[0]?.translationKey || "";

  let sortedLinks = [];

  if(regexUpdateNoteMachine.test(firstLink) || regexUpdateNoteGsta.test(firstLink)) {
    sortedLinks= sortByVersion(links);
  }
  else if (regexNotice.test(firstLink)) {
    sortedLinks = normalizeNoticeFileNames(links);
  }
  else {
    sortedLinks = copyObject(links);
  }
  return sortedLinks;
};

export const LOG = {
  NOTICE_APPLICATION: "NOTICE_APPLICATION",
  UPDATE_APPLICATION: "UPDATE_APPLICATION",
  NOTICE_SIMULATION: "NOTICE_SIMULATION",
  UPDATE_SIMULATION: "UPDATE_SIMULATION"
}

const FILES_TYPES = {
  NOTICE: "notice",
  SIMULATION_CONTENT: "simulationContent",
  TRAINING_CATALOG: "trainingCatalog",
  UPDATE_NOTE: "updateNote",
}

export const getLogValue = (tsKey, machines) => {
    let logValue = "";

    if (tsKey.includes(FILES_TYPES.UPDATE_NOTE)) {
      logValue = machines.some((machine) => tsKey.includes(machine.code)) || machines.some((machine) => tsKey.includes(machine.softwareCode))
        ? LOG.UPDATE_SIMULATION
        : LOG.UPDATE_APPLICATION;
    }
    if (tsKey.includes(FILES_TYPES.SIMULATION_CONTENT) || tsKey.includes(FILES_TYPES.TRAINING_CATALOG)) {
      logValue = LOG.NOTICE_SIMULATION;
    }
    if (tsKey.includes(FILES_TYPES.NOTICE)) {
      logValue = LOG.NOTICE_APPLICATION;
    }

    return logValue;
  };
